export default __webpack_public_path__ + "static/NetworkAi-Solution-brief-9a900ce1da32a5bfb468eeba09518dd3.pdf";